import Phaser from 'phaser';

export default class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  preload() {
    // Nothing to preload from disk in Boot; we create textures procedurally
  }

  create() {
    this.scene.start('PreloadScene');
  }
}
